module.exports = __webpack_public_path__ + "img/36.55c9e128.jpg";